import React from 'react';
import ComingSoonPage from '../components/ComingSoonPage';
import { useAuth } from '../contexts/AuthContext';

export default function Guides() {
  const { utilisateur, estConnecte } = useAuth();
  const isGuide =
    utilisateur?.user_type === 'guide' ||
    (utilisateur?.roles || []).some((r) => r.role === 'guide' && r.active !== false);

  let ctaLink;
  let ctaLabel;
  if (!estConnecte) {
    ctaLink = '/signup';
    ctaLabel = { fr: 'Vous êtes guide ? Inscrivez-vous', en: 'Are you a guide? Sign up' };
  } else if (isGuide) {
    ctaLink = '/my-profile';
    ctaLabel = { fr: 'Gérer mon profil guide', en: 'Manage my guide profile' };
  } else {
    ctaLink = '/my-profile';
    ctaLabel = { fr: 'Ajouter le rôle Guide', en: 'Add the Guide role' };
  }

  return (
    <ComingSoonPage
      title={{
        fr: 'Trouvez votre guide de chasse vérifié',
        en: 'Find your verified hunting guide',
      }}
      sousTitre={{
        fr: 'Service en développement',
        en: 'Service in development',
      }}
      description={{
        fr: "Bientôt, parcourez des profils de guides certifiés à travers le Canada. Recherche par espèce, région et province d'opération, réservation en ligne et évaluations clients.",
        en: 'Soon, browse certified guide profiles across Canada. Search by species, region and province of operation, online booking and client reviews.',
      }}
      cartes={[
        {
          icon: '🗺️',
          title: { fr: 'Recherche par espèce et région', en: 'Search by species and region' },
          description: {
            fr: 'Filtrez par orignal, cerf, ours, dindon ou par province et zone de chasse.',
            en: 'Filter by moose, deer, bear, turkey or by province and hunting zone.',
          },
        },
        {
          icon: '✅',
          title: { fr: 'Profils vérifiés', en: 'Verified profiles' },
          description: {
            fr: "Chaque guide fournit 3 références par province d'opération avant publication.",
            en: 'Each guide provides 3 references per province of operation before publication.',
          },
        },
        {
          icon: '⭐',
          title: { fr: 'Évaluations clients', en: 'Client reviews' },
          description: {
            fr: 'Notes et avis bidirectionnels après chaque sortie pour maintenir un service de qualité.',
            en: 'Bidirectional ratings after every outing to maintain service quality.',
          },
        },
      ]}
      cta={{
        label: ctaLabel,
        link: ctaLink,
      }}
    />
  );
}
